import { j as r } from "./jsx-runtime-DywqP_6a.js";
import { _ as s } from "./index-CrcNWbel.js";
import { Search as n } from "lucide-react";
import * as t from "react";
import { D as p, a as l } from "./Dialog-VIMic7xI.js";
import { c as o } from "./cn-dYga0KKN.js";
const m = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  s,
  {
    ref: d,
    className: o(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      a
    ),
    ...e
  }
));
m.displayName = s.displayName;
const k = ({
  children: a,
  command: e,
  content: d,
  ...i
}) => /* @__PURE__ */ r.jsx(p, { ...i, children: /* @__PURE__ */ r.jsx(
  l,
  {
    ...d,
    className: o(
      "overflow-hidden p-0 shadow-lg top-[15vh] translate-y-[0%]",
      d?.className
    ),
    "aria-describedby": void 0,
    children: /* @__PURE__ */ r.jsx(
      m,
      {
        ...e,
        className: o(
          "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
          e?.className
        ),
        children: a
      }
    )
  }
) }), c = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ r.jsx(n, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ r.jsx(
    s.Input,
    {
      ref: d,
      className: o(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        a
      ),
      ...e
    }
  )
] }));
c.displayName = s.Input.displayName;
const u = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx("div", { className: "flex items-center", "cmdk-input-wrapper": "", children: /* @__PURE__ */ r.jsx(
  s.Input,
  {
    ref: d,
    className: o(
      "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
      "focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring",
      a
    ),
    ...e
  }
) }));
u.displayName = s.Input.displayName;
const f = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  s.List,
  {
    ref: d,
    className: o("max-h-[300px] overflow-y-auto overflow-x-hidden", a),
    ...e
  }
));
f.displayName = s.List.displayName;
const x = t.forwardRef((a, e) => /* @__PURE__ */ r.jsx(
  s.Empty,
  {
    ref: e,
    className: "py-6 text-center text-sm",
    ...a
  }
));
x.displayName = s.Empty.displayName;
const g = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  s.Group,
  {
    ref: d,
    className: o(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      a
    ),
    ...e
  }
));
g.displayName = s.Group.displayName;
const h = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  s.Separator,
  {
    ref: d,
    className: o("-mx-1 h-px bg-border", a),
    ...e
  }
));
h.displayName = s.Separator.displayName;
const y = t.forwardRef(({ className: a, ...e }, d) => /* @__PURE__ */ r.jsx(
  s.Item,
  {
    ref: d,
    className: o(
      "relative flex cursor-default gap-2 select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      a
    ),
    ...e
  }
));
y.displayName = s.Item.displayName;
export {
  f as C,
  g as a,
  y as b,
  k as c,
  c as d,
  x as e,
  m as f,
  u as g
};
//# sourceMappingURL=Command-TEBTONf1.js.map
